/**
 * AI profile enumerations — ONE tuple each, consumed by the zod schemas, the
 * `AIProfileType` union, the ai_profiles.* tool parameter enums and the web editor.
 * The `ai_profiles.type` drizzle column enum mirrors `AI_PROFILE_TYPES`.
 */
export const AI_PROFILE_TYPES = ['assistant', 'automation', 'api', 'developer'];
/** Claude CLI `--permission-mode` values a profile may pin. */
export const CLAUDE_CLI_PERMISSION_MODES = [
    'default',
    'acceptEdits',
    'bypassPermissions',
    'plan',
    'auto',
    'dontAsk',
];
/**
 * Slug of the seeded Desktop Assistant profile (DM #1683). SINGLE SOURCE for both
 * sides of the wiring: the api seed writes the row under it, the web dock resolves
 * its id from it. Never a numeric id — an id is env-local and drifts.
 */
export const DESKTOP_ASSISTANT_PROFILE_SLUG = 'desktop-assistant';
//# sourceMappingURL=aiProfile.js.map